// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Subscriptions_AdminTransactionRefundInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /subscriptions/admin/transactions/{id}/refunded (S12/M3c · D5).
 *
 * No body required — id is a URL path parameter, and there is deliberately
 * nothing else for the caller to send. The staff member is not describing a
 * refund, they are acknowledging one they already executed in the gateway's
 * own panel: an amount or a date read from the request would be a claim the
 * platform cannot verify, so the row keeps the money it already recorded.
 */
import { registerContract } from './validate'

export interface Subscriptions_AdminTransactionRefundInput {}

registerContract('Subscriptions_AdminTransactionRefundInput', {})
